import { api_host,api_auth} from '../../common/globals/constants';

export const getPdfPeriodical = async(data) => {
    // const response = await fetch(`http://0.0.0.0:5000/graficos`, {
    const response = await fetch(`https://api-ar.atentus.com/graficos`, {
        method: 'POST',
        body: data
    })
    console.log({response});
    
    return response.ok
}





// export const getLastAvailabilityStep = (objetivo_id, id_user, token) => fetch(api_host+`/reporte/online/indicadores/StepsLastAvailabilityObjetive/?user=${id_user}&objetivoId=${objetivo_id}&token=${token}`)
// .then(response => response.json())